import { Box } from "@mui/material";
import styled from "styled-components";

export const ReviewCardStyled = styled(Box)`
  background: var(--pure-white-color);
  padding: 20px;
  box-shadow: 0px 0px 4px 0px #f0f0f066;
  border-radius: 16px;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
  .review-content {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: space-between;
    .title-and-sub-title {
      display: flex;
      flex-direction: column;
      gap: 4px;
      .title {
        font-weight: 500;
        font-size: 18px;
        color: var(--coal-black-color);
      }
      .sub-title {
        font-weight: 400;
        font-size: 16px;
        color: var(--muted-gray-color);
      }
    }
    .reason {
      cursor: pointer;
      font-weight: 500;
      font-size: 12px;
      color: var(--royal-blue-color);
      background: var(--light-blue-color);
      height: 44px;
      border-radius: 88px;
      width: 1;
      padding: 10px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }
  .edit-button-container {
    display: flex;
    align-items: center;
    .edit-button {
      cursor: pointer;
      font-weight: 500;
      font-size: 12px;
      color: var(--royal-blue-color);
      background: var(--light-blue-color);
      height: 44px;
      border-radius: 88px;
      width: 195px;
      padding: 10px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
    .edit-icon-wrapper {
      display: none;
    }

    @media (max-width: 576px) {
      .edit-button {
        display: none;
      }
      .edit-icon-wrapper {
        display: block;
      }
    }
  }
`;
